import _ from 'lodash';
import { setStyle, createElement, addEventListener } from '../utils';
import { InnoMarketingCardFormConfig } from '../index';
import { MarketingCardService } from '../base';
import { InnoCardCssString } from './style';
import { getTemplate } from './templale';
const INNO_CARD_STYLE_ID = 'InnoCardStyle';
const appendStyle = () => {
    if (!document.getElementById(INNO_CARD_STYLE_ID)) {
        const style = document.createElement('style');
        style.id = INNO_CARD_STYLE_ID;
        style.textContent = InnoCardCssString;
        document.head.appendChild(style);
    }
};
const removeStyle = () => {
    const style = document.getElementById(INNO_CARD_STYLE_ID);
    if (style) {
        document.head.removeChild(style);
    }
};
// 字段key：tenant_version
export var EINNO_TENANTVERSION;
(function (EINNO_TENANTVERSION) {
    EINNO_TENANTVERSION["professional"] = "professional";
    EINNO_TENANTVERSION["standard"] = "standard";
})(EINNO_TENANTVERSION || (EINNO_TENANTVERSION = {}));
// 字段key: customer_type
export var EINNO_CUSTOMERTYPE;
(function (EINNO_CUSTOMERTYPE) {
    EINNO_CUSTOMERTYPE["official"] = "official";
    EINNO_CUSTOMERTYPE["trial"] = "trial"; // 试用
})(EINNO_CUSTOMERTYPE || (EINNO_CUSTOMERTYPE = {}));
export class InnoMarketingCardService extends MarketingCardService {
    constructor(params) {
        super(params);
        this.clickFunc = params.clickFunc;
        this.closeFunc = params.closeFunc;
        this.formConfig = InnoMarketingCardFormConfig;
    }
    getStyle(isHovered) {
        const { color } = this._originCard;
        if (!color)
            return;
        return isHovered ? {
            'border-color': color,
        } : {};
    }
    dispose() {
        removeStyle();
        this.el = undefined;
        this.disposes.forEach((dispose) => dispose());
    }
    render() {
        var _a, _b;
        appendStyle();
        const compiled = _.template(getTemplate((_a = this.card) === null || _a === void 0 ? void 0 : _a.tenant_version), { interpolate: /{{([\s\S]+?)}}/g });
        const containerDiv = createElement('div');
        containerDiv.className = `pt-inno-card ${((_b = this.card) === null || _b === void 0 ? void 0 : _b.tenant_version) === EINNO_TENANTVERSION.standard ? 'mini' : 'large'}`;
        containerDiv.innerHTML = compiled(this.card);
        const buttonDiv = containerDiv.querySelector('.pt-inno-card__btn');
        const closeBtn = containerDiv.querySelector('.pt-inno-card__close');
        setStyle(buttonDiv, { background: `${this.card.color}` });
        this.disposes.push(addEventListener(containerDiv, 'mouseover', () => {
            setStyle(containerDiv, this.getStyle(true));
        }));
        this.disposes.push(addEventListener(containerDiv, 'mouseout', () => {
            containerDiv.style.cssText = '';
        }));
        this.disposes.push(addEventListener(containerDiv, 'click', () => this.clickFunc && this.clickFunc(this._originCard)));
        this.disposes.push(addEventListener(closeBtn, 'click', (evt) => {
            evt === null || evt === void 0 ? void 0 : evt.stopPropagation();
            this.closeFunc && this.closeFunc(this.el);
        }));
        this.el = containerDiv;
        return containerDiv;
    }
}
InnoMarketingCardService.componentName = 'InnoMarketingCard';
//# sourceMappingURL=index.js.map